<template>
	<v-card flat tile class="pt-7 pivot-table-container">
		<div :class="tabId" class="pivot-table" :ref="tabId"></div>
	</v-card>
</template>

<script>
	import $ from 'jquery';
	import XLSX from 'xlsx';
	import { eventBus } from '@/eventBus';
	import FileSaver from '@/assets/FileSaver.js';
	import 'jquery-ui-dist/jquery-ui';
	import 'jquery-ui-dist/jquery-ui.min.css';
	import 'pivottable/dist/pivot.js';
	import 'pivottable/dist/pivot.css';
	import '@/assets/plotly_renderers.js';
	import '@/assets/nrecopivottableext.js';
	import '@/assets/pivottableext.css';
	import '@/assets/plotly-basic.min.js';
	import CryptoJS from "crypto-js";

	const numberFormat = $.pivotUtilities.numberFormat;
	const swFormat = numberFormat({ thousandsSep: ' ', decimalSep: ',' });
	const swFormatRound = numberFormat({
		thousandsSep: ' ',
		decimalSep: ',',
		digitsAfterDecimal: 0,
	});

	const companyID = CryptoJS.AES.decrypt(localStorage.getItem("companyID"), process.env.VUE_APP_GOOGLE_SITE_KEY).toString(
		CryptoJS.enc.Utf8
	);

	const customSum = function(formatter = swFormat, country, round) {
		if (round) {
			formatter = swFormatRound;
		}
		return function(arg) {
			let attr;
			attr = arg[0];
			return function(data, rowKey, colKey) {
				return {
					sum: 0,
					divideBy: 0,
					theCountry: 0,
					shouldConvert: 0,
					push: function(record) {
						if (!isNaN(parseFloat(record[attr]))) {
							if (record['Measurement'] == 'AIP' || record['Measurement'] == 'AUP') {
								this.divideBy += 1;
							} else {
								this.divideBy = 1;
							}

							this.shouldConvert = false;

							if (record['Measurement'].includes('AIP') || record['Measurement'].includes('AUP')) {
								this.shouldConvert = true;
							}

							this.theCountry = record['Country'];
							let theSum = parseFloat(record[attr]);

							const currencyRate = JSON.parse(localStorage.getItem('user')).currency_rate;

							if (country == 'SEK') {
								if (this.theCountry == 'Denmark' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.SEK / 1) * (1 / currencyRate.DKK));
								}

								if (this.theCountry == 'Norway' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.SEK / 1) * (1 / currencyRate.NOK));
								}

								if (this.theCountry == 'Finland' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.SEK / 1) * 1);
								}

								if (this.theCountry == 'Iceland' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.SEK / 1) * (1 / currencyRate.ISK));
								}
							}

							if (country == 'DKK') {
								if (this.theCountry == 'Sweden' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.DKK / 1) * (1 / currencyRate.SEK));
								}

								if (this.theCountry == 'Norway' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.DKK / 1) * (1 / currencyRate.NOK));
								}

								if (this.theCountry == 'Finland' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.DKK / 1) * 1);
								}

								if (this.theCountry == 'Iceland' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.DKK / 1) * (1 / currencyRate.ISK));
								}
							}

							if (country == 'NOK') {
								if (this.theCountry == 'Sweden' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.NOK / 1) * (1 / currencyRate.SEK));
								}

								if (this.theCountry == 'Denmark' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.NOK / 1) * (1 / currencyRate.DKK));
								}

								if (this.theCountry == 'Finland' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.NOK / 1) * 1);
								}

								if (this.theCountry == 'Iceland' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.NOK / 1) * (1 / currencyRate.ISK));
								}
							}

							if (country == 'ISK') {
								if (this.theCountry == 'Sweden' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.ISK / 1) * (1 / currencyRate.SEK));
								}

								if (this.theCountry == 'Norway' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.ISK / 1) * (1 / currencyRate.NOK));
								}

								if (this.theCountry == 'Denmark' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.ISK / 1) * (1 / currencyRate.DKK));
								}

								if (this.theCountry == 'Finland' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.ISK / 1) * 1);
								}
							}

							if (country == 'EUR') {
								if (this.theCountry == 'Sweden' && this.shouldConvert) {
									theSum = theSum * (1 * (1 / currencyRate.SEK));
								}

								if (this.theCountry == 'Norway' && this.shouldConvert) {
									theSum = theSum * (1 * (1 / currencyRate.NOK));
								}

								if (this.theCountry == 'Denmark' && this.shouldConvert) {
									theSum = theSum * (1 * (1 / currencyRate.DKK));
								}

								if (this.theCountry == 'Iceland' && this.shouldConvert) {
									theSum = theSum * (1 * (1 / currencyRate.ISK));
								}
							}

							if (country == 'USD') {
								if (this.theCountry == 'Sweden' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.USD / 1) * (1 / currencyRate.SEK));
								}

								if (this.theCountry == 'Norway' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.USD / 1) * (1 / currencyRate.NOK));
								}

								if (this.theCountry == 'Denmark' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.USD / 1) * (1 / currencyRate.DKK));
								}

								if (this.theCountry == 'Iceland' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.USD / 1) * (1 / currencyRate.ISK));
								}

								if (this.theCountry == 'Finland' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.USD / 1) * 1);
								}
							}

							if (country == 'CAD') {
								if (this.theCountry == 'Sweden' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.CAD / 1) * (1 / currencyRate.SEK));
								}

								if (this.theCountry == 'Norway' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.CAD / 1) * (1 / currencyRate.NOK));
								}

								if (this.theCountry == 'Denmark' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.CAD / 1) * (1 / currencyRate.DKK));
								}

								if (this.theCountry == 'Iceland' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.CAD / 1) * (1 / currencyRate.ISK));
								}

								if (this.theCountry == 'Finland' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.CAD / 1) * 1);
								}
							}

							if (country == 'GBP') {
								if (this.theCountry == 'Sweden' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.GBP / 1) * (1 / currencyRate.SEK));
								}

								if (this.theCountry == 'Norway' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.GBP / 1) * (1 / currencyRate.NOK));
								}

								if (this.theCountry == 'Denmark' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.GBP / 1) * (1 / currencyRate.DKK));
								}

								if (this.theCountry == 'Iceland' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.GBP / 1) * (1 / currencyRate.ISK));
								}

								if (this.theCountry == 'Finland' && this.shouldConvert) {
									theSum = theSum * ((currencyRate.GBP / 1) * 1);
								}
							}

							return (this.sum += theSum);
						}
					},
					value: function() {
						if (this.divideBy > 1) {
							return this.sum / this.divideBy;
						}

						return this.sum;
					},
					format: formatter,
					numInputs: attr != null ? 0 : 1,
				};
			};
		};
	};

	const nrecoPivotExt = new window.NRecoPivotTableExtensions({
		wrapWith: '<div class="pvtTableRendererHolder"></div>',
		fixedHeaders: true,
	});

	const stdRendererNames = ['Table', 'Table Barchart', 'Heatmap', 'Row Heatmap', 'Col Heatmap'];

	// Remove charts
	delete $.pivotUtilities.plotly_renderers['Scatter Chart'];
	delete $.pivotUtilities.plotly_renderers['Horizontal Bar Chart'];
	delete $.pivotUtilities.plotly_renderers['Horizontal Stacked Bar Chart'];

	// Extend nreco filter
	const wrappedRenderers = $.extend($.pivotUtilities.renderers, $.pivotUtilities.plotly_renderers);
	$.each(stdRendererNames, function() {
		wrappedRenderers[this] = nrecoPivotExt.wrapTableRenderer(wrappedRenderers[this]);
	});

	/**
	 * @module PivotTable
	 *
	 * @vue-prop {string} tabId=null - Current tab ID
	 * @vue-prop {array<object>} [pivotData=[]] - The data that should be rendered in the pivot table
	 * @vue-prop {object} pivotConfig={} - Pivot table configs for corresponding tab
	 *
	 * @vue-data {object} [config={}] - Generic pivot table configs
     * 
	 * @vue-data {array<string>} [config.cols=['Year', 'Month', 'Measurement']] - Attribute names to use as columns
	 * @vue-data {array<string>} [config.rows=['ATC', 'Product Name']] - Attribute names to use as rows
	 * @vue-data {array<string>} [config.vals=['Value']] - Attribute names to prepopulate in vals area
     * 
	 * @vue-data {object<function>} [config.aggregators={}] - Dictionary of generators for aggregations functions in dropdown
	 * @vue-data {function} [config.aggregators.SEK='SEK'] - Format "Value" to SEK currency
	 * @vue-data {function} [config.aggregators.NOK='NOK'] - Format "Value" to NOK currency
	 * @vue-data {function} [config.aggregators.DKK='DKK'] - Format "Value" to DKK currency
	 * @vue-data {function} [config.aggregators.ISK='ISK'] - Format "Value" to ISK currency
	 * @vue-data {function} [config.aggregators.EUR='EUR'] - Format "Value" to EUR currency
	 * @vue-data {function} [config.aggregators.USD='USD'] - Format "Value" to USD currency
	 * @vue-data {function} [config.aggregators.CAD='CAD'] - Format "Value" to CAD currency
	 * @vue-data {function} [config.aggregators.GBP='GBP'] - Format "Value" to GBP currency
     * 
	 * @vue-data {string} config.aggregatorName='SEK' - The aggregator function we want to use
	 * @vue-data {object<function>} config.renderers=wrappedRenderers - Dictionary of rendering functions, in this case where we wrap it with the nreco filter
	 * @vue-data {string} config.rendererName='Table' - Renderer to prepopulate in dropdown
	 * @vue-data {array<string>} [config.hiddenAttributes=['id', 'Value', 'Article', 'Location', 'Vet']] - Attribute names to omit from the UI
	 * @vue-data {boolean} config.autoSortUnusedAttrs=true - Controls whether or not unused attributes are kept sorted in the UI
     * 
	 * @vue-data {object<function>} [config.derivedAttributes={}] - Used to add new attributes to the original data set
	 * @vue-data {function} config.derivedAttributes.Veterinary - Format Veterinary attribute 
	 * @vue-data {function} config.derivedAttributes.Region - Format Region attribute 
	 * @vue-data {function} config.derivedAttributes.PSG - Format PSG attribute 
	 * @vue-data {function} config.derivedAttributes.EGID - Format EGID attribute 
	 * @vue-data {function} config.derivedAttributes.Company - Format Company attribute 
	 * @vue-data {function} config.derivedAttributes.PI - Format PI attribute 
	 * @vue-data {function} config.derivedAttributes.Source - Format Source attribute 
	 * @vue-data {function} config.derivedAttributes.Size - Format Size attribute 
	 * @vue-data {function} [config.derivedAttributes['LP Name']] - Format LP Name attribute 
	 * @vue-data {function} [config.derivedAttributes['Generic Type']] - Format Generic Type attribute 
	 * @vue-data {function} [config.derivedAttributes['Sales Channel']] - Format Sales Channel attribute 
	 * @vue-data {function} [config.derivedAttributes['NPL Pack Id']] - Format NPL Pack Id attribute 
	 * @vue-data {function} [config.derivedAttributes['Leading Product Name']] - Format Leading Product Name attribute 
	 * 
     * @vue-data {object|function} [config.sorters={}] - Accessed or called with an attribute name and can return a function which can be used as an argument to array.sort for output purposes
     * @vue-data {object|function} [config.sorters.Month=['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ]] - Sort months
	 * 
     * @vue-data {object} config.rendererOptions={} - Options passed through to renderer
     * @vue-data {string} config.rendererOptions.nrecoTabId='' - Pass the current tab ID to nreco filter so we can keep track of the state of the toggle buttons
     * 
	 * @vue-data {object} config.rendererOptions.plotly={} - Used to control title, axes etc.
	 * @vue-data {object} [config.rendererOptions.height=window.innerHeight / 1.2 - 35] - Set the inner height 
	 * @vue-data {string} config.rendererOptions.plotly.title='' - Parent layout title 
	 * @vue-data {object} config.rendererOptions.plotly.yaxis={} - Layout yaxis
	 * @vue-data {object} config.rendererOptions.plotly.yaxis.title={} - Layout yaxis title 
	 * @vue-data {object} config.rendererOptions.plotly.yaxis.title.text='' - Set layout yaxis title text
     * 
	 * @vue-data {object} config.rendererOptions.plotlyConfig={} - Used to control various aspects of the interactivity/behaviour of the chart including the modebar
	 * @vue-data {boolean} config.rendererOptions.plotlyConfig.displaylogo=false - Display Plotly logo on the modebar
	 * @vue-data {array<string>} [config.rendererOptions.plotlyConfig.modeBarButtonsToRemove=['select2d', 'lasso2d', 'resetScale2d']] - Remove modebar buttons
	 * 
	 * @vue-data {array} [config.pivot_cols=[]] - Store pivot columns so that we can save what columns is used
	 * @vue-data {array} [config.pivot_rows=[]] - Store pivot rows so that we can save what rows is used
	 * @vue-data {boolean} config.showRounded=true - Display rounded values in pivot table
	 * @vue-data {boolean} config.showTotal=true - Display totals for column/row values
	 *
	 * @vue-event {object} get-pivot-cols-rows - Get pivot table columns/rows attributes for corresponding table which could be from a saved search
	 * @vue-event {object} set-pivot-cols-rows - Set pivot table columns/rows attributes for corresponding table
	 *
	 * @see {@link https://github.com/nicolaskruchten/pivottable/wiki|PivotTable.js}
	 */

	export default {
		name: 'PivotTable',
		props: {
			tabId: {
				required: true,
				type: String,
			},
			pivotData: {
				required: true,
				type: Array,
			},
			pivotConfig: {
				type: Object,
			},
		},
		data() {

			// Parameters that were originally hidden in the pivottable
			let hiddenOriginals = ['id', 'Value', 'Article', 'Location', 'Vet'];

			// Parameters we want to hide for Gilead
			let hiddenForGilead = ['Dose OP exp month', 'Dose OP', 'Substitutable'];
			
			let hidden_attributes = [];

			// If logged in user has company id 13 (Gilead)
			// Concatenate the two arrays hiddenOriginals and hiddenForGilead
			if(companyID === '13'){
				hidden_attributes = [...hiddenOriginals, ...hiddenForGilead];
			}else{
				// Else hide the originals
				hidden_attributes = hiddenOriginals;
			}

			return {
				config: {
					cols:
						this.pivotConfig.cols && this.pivotConfig.cols.length
							? this.pivotConfig.cols
							: ['Year', 'Month', 'Measurement'],
					rows:
						this.pivotConfig.rows && this.pivotConfig.rows.length
							? this.pivotConfig.rows
							: ['ATC', 'Product Name'],
					vals: ['Value'],
					aggregators: {
						SEK: () => {
							return customSum(swFormat, 'SEK', this.showRounded)(['Value']);
						},
						NOK: () => {
							return customSum(swFormat, 'NOK', this.showRounded)(['Value']);
						},
						DKK: () => {
							return customSum(swFormat, 'DKK', this.showRounded)(['Value']);
						},
						ISK: () => {
							return customSum(swFormat, 'ISK', this.showRounded)(['Value']);
						},
						EUR: () => {
							return customSum(swFormat, 'EUR', this.showRounded)(['Value']);
						},
						USD: () => {
							return customSum(swFormat, 'USD', this.showRounded)(['Value']);
						},
						CAD: () => {
							return customSum(swFormat, 'CAD', this.showRounded)(['Value']);
						},
						GBP: () => {
							return customSum(swFormat, 'GBP', this.showRounded)(['Value']);
						},
					},
					aggregatorName: 'SEK',
					renderers: wrappedRenderers,
					rendererName: 'Table',
					hiddenAttributes: hidden_attributes,
					autoSortUnusedAttrs: true,
					derivedAttributes: {
						Veterinary: function(mp) {
							if (mp['Veterinary'] === 1) {
								return 'Yes';
							} else {
								return 'No';
							}
						},
						Region: function(mp) {
							if (!mp['Region']) {
								return 'N/A';
							}
						},
						PSG: function(mp) {
							if (!mp['PSG']) {
								return 'N/A';
							}
						},
						EGID: function(mp) {
							if (!mp['EGID']) {
								return 'N/A';
							}
						},
						Company: function(mp) {
							if (mp['Company'] === '') {
								return 'N/A';
							}
						},
						PI: function(mp) {
							if (mp['PI'] === '' || mp['PI'] == null) {
								return 'N/A';
							}
						},
						Source: function(mp) {
							if (!mp['Source']) {
								return 'N/A';
							}
						},
						Size: function(mp) {
							if (!mp['Size']) {
								return 'N/A';
							}
						},
					
						'Generic Type': function(mp) {
							if (!mp['Generic Type']) {
								return 'N/A';
							}
						},
						'Sales Channel': function(mp) {
							if (mp['Sales Channel'] === 'Hos') {
								return 'Hospital';
							}

							if (mp['Sales Channel'] === 'Pha') {
								return 'Pharmacy';
							}
						},
						'NPL Pack Id': function(mp) {
							if (mp['NPL Pack Id'] === '0') {
								return 'N/A';
							}
						},
						'Leading Product Name': function(mp) {
							if (!mp['Leading Product Name']) {
								return 'N/A';
							}
						},
						'Dose OP': function(mp) {
								if (!mp['Dose OP']) {
									return 'N/A';
								}else if(mp['Dose OP'] === 'Y'){
									return 'Yes';
								}else if(mp['Dose OP'] === 'N'){
									return 'No';
								}else{
									return mp['Dose OP'];
								}	
							},
						'Dose OP exp month': function(mp) {
								if (!mp['Dose OP exp month']) {
									return 'N/A';
								}else{
									return mp['Dose OP exp month'];
								}
							},
						'Substitutable': function(mp) {
								if (!mp['Substitutable']) {
									return 'N/A';
								}else if(mp['Substitutable'] === 'Y'){
									return 'Yes';
								}else if(mp['Substitutable'] === 'N'){
									return 'No';
								}else{
									return mp['Substitutable'];
								}	
							},
					},
					sorters: {
						Month: $.pivotUtilities.sortAs([
							'January',
							'February',
							'March',
							'April',
							'May',
							'June',
							'July',
							'August',
							'September',
							'October',
							'November',
							'December',
						]),
					},
					rendererOptions: {
						plotly: {
							title: '',
							yaxis: {
								title: {
									text: '',
								},
							},
							height: window.innerHeight / 1.2 - 35,
						},
						plotlyConfig: {
							displaylogo: false,
							modeBarButtonsToRemove: ['select2d', 'lasso2d', 'resetScale2d'],
						},
						nrecoTabId: this.tabId,
					},
				},
				pivot_cols: [],
				pivot_rows: [],
				showRounded: true,
				showTotal: true,
			};
		},

        // Fetch pivot table columns/rows when component gets created  
		created() {
			eventBus.$on('get-pivot-cols-rows', () => this.pivotColsRows());
		},

		// Initiate pivot table
		mounted: function() {
			this.initTable();
		},

		/**
		 * Listen for value changes in pivotData
		 *
		 * @property {function} pivotData - Re-render pivot table if data changes
		 */
		watch: {
			pivotData: function() {
				this.initTable();
			},
		},
		methods: {

            /**
             * Fetch columns/rows for corresponding pivot table 
             * 
             * - Find columns/rows in current tab
             * - Emit the payload so we can store the values 
             */
			pivotColsRows() {
				const pivotCols = this.pivot_cols;
				const pivotRows = this.pivot_rows;

				// Remove whitespace & "▾"
				const regex = str => str.replace(/\s+\▾/g, '');

				// Get only unique values
				const uniqueArr = arr => [...new Set(arr)];

				// Get pivot cols attributes
				$(`.pivot-table.${this.tabId} .pvtAxisContainer.pvtHorizList.pvtCols.pvtUiCell.ui-sortable`)
					.find('li')
					.each(function(idx, el) {
						pivotCols.push(regex(el.innerText));
					});

				// Get pivot rows attributes
				$(`.pivot-table.${this.tabId} .pvtAxisContainer.pvtRows.pvtUiCell.ui-sortable`)
					.find('li')
					.each(function(idx, el) {
						pivotRows.push(regex(el.innerText));
					});

				eventBus.$emit('set-pivot-cols-rows', {
					pivot_cols: uniqueArr(pivotCols),
					pivot_rows: uniqueArr(pivotRows),
				});
			},

            /**
             * Initiate pivot table 
             * 
             * - Set the aggregators that are to be used which could be from a saved search 
             * - Get currency list from local storage and format it
             * - Render pivot UI 
             * - Add show/rounded/export button
             */
			initTable() {
				const aggregators = this.config.aggregators;

				// Get currencies
				const currencyList = JSON.parse(localStorage.getItem('user')).currency_rate;

				// Get key of each currency
				const currencyKeys = Object.keys(currencyList);
				currencyKeys.push('EUR');

				// Object.keys to list all properties in raw (the original data), then
				// Array.prototype.filter to select keys that are present in the allowed list, using
				// Array.prototype.includes to make sure they are present
				// Array.prototype.reduce to build a new object with only the allowed properties.
				// This will make a shallow copy with the allowed properties (but won't copy the properties themselves).
				const filtered = arr =>
					Object.keys(aggregators)
						.filter(key => arr.includes(key))
						.reduce((obj, key) => {
							obj[key] = aggregators[key];
							return obj;
						}, {});

				this.config.aggregators = filtered(currencyKeys);

				const onRefreshConfig = {
					onRefresh: conf => {
						if (localStorage.getItem(this.tabId)) {
							const { total, rounded } = JSON.parse(localStorage.getItem(this.tabId));

							this.showTotal = total;
							this.showRounded = rounded;
						}

						// Keep displaying totals when a filter is added/removed or rounded
						if (this.showTotal) {
							$(`.${this.tabId}`)
								.find('.pvtTotal, .pvtTotalLabel, .pvtGrandTotal')
								.show();
							$(`input[name="total ${this.tabId}"]`).prop('checked', true);
						} else {
							$(`.${this.tabId}`)
								.find('.pvtTotal, .pvtTotalLabel, .pvtGrandTotal')
								.hide();
							$(`input[name="total ${this.tabId}"]`).prop('checked', false);
						}

						if (this.showRounded /* && this.execOnce === 1 */) {
							// this.initTable();
							$(`input[name="rounded ${this.tabId}"]`).prop('checked', true);
						} else {
							$(`input[name="rounded ${this.tabId}"]`).prop('checked', false);
						}

						// Show/hide buttons based on selected renderer
						const rendererName = conf.rendererName;
						const exportBtn = $(`.pivot-table.${this.tabId} .pivot-btn.export`);
						const totalBtn = $(`.pivot-table.${this.tabId} .toggle-total`);
						const roundedBtn = $(`.pivot-table.${this.tabId} .toggle-rounded`);

						rendererName === 'Table' ? exportBtn.show() : exportBtn.hide();

						if (rendererName.includes('Chart')) {
							exportBtn.hide();
							totalBtn.hide();
							roundedBtn.hide();
						} else {
							totalBtn.show();
							roundedBtn.show();
						}
					},
				};

				// Render pivot UI
				$(this.$refs[this.tabId]).pivotUI(this.pivotData, Object.assign(this.config, onRefreshConfig));

				// Create total and rounded sliders and export button
				$(`.pivot-table.${this.tabId} .pvtAxisContainer.pvtHorizList.pvtCols.pvtUiCell.ui-sortable`).prepend(
					`<div class="toggle-container" style="margin-bottom: 8px; padding-bottom: 6px; border-bottom: 1px solid lightgray">
                    <div class="toggle-total" style="display: inline; padding: 0 6px">
                        <span>Total</span>
                        <label class="switch">
                            <input name="total ${this.tabId}" type="checkbox">
                            <span class="slider round"></span> 
                        </label>
                    </div>
                    <div class="toggle-rounded" style="display: inline; padding: 0 6px">
                        <span>Rounded</span>
                        <label class="switch">
                            <input name="rounded ${this.tabId}" type="checkbox">
                            <span class="slider round"></span>
                        </label>
                    </div>
                    <button class='pivot-btn export' style="margin-left: 14px;">
                        <span class="v-btn__content">
                            <span style="padding-right: 4px">Export</span>
                            <i aria-hidden="true" class="v-icon notranslate mdi mdi-download theme--dark" style="font-size: 18px"></i>
                        </span>
                    </button>
                </div>`
				);

				// Export table
				$(`.pivot-table.${this.tabId} .pivot-btn.export`).on('click', () => {
					// Specify which table we want to export
					let table = $('.' + this.tabId).find('table.pvtTable');
					table.attr('id', this.tabId + '_pvtTable');

					this.exportTableToExcel('xlsx', this.tabId + '_pvtTable');
				});

				// Toggle rounded
				$(`.pivot-table.${this.tabId} .toggle-rounded`).on('change', e => {
					this.showRounded = $(`input[name="rounded ${this.tabId}"]`).is(':checked');

					if (e) {
						localStorage.setItem(
							this.tabId,
							JSON.stringify({ total: this.showTotal, rounded: this.showRounded })
						);
					}

					if (this.showRounded) {
						this.initTable();
						$(`input[name="rounded ${this.tabId}"]`).prop('checked', true);
					} else {
						this.initTable();
						$(`input[name="rounded ${this.tabId}"]`).prop('checked', false);
					}
				});

				// Toggle total
				$(`.pivot-table.${this.tabId} .toggle-total`).on('change', e => {
					const checked = $(`input[name="total ${this.tabId}"]`).is(':checked');

					if (e) {
						localStorage.setItem(this.tabId, JSON.stringify({ total: checked, rounded: this.showRounded }));
					}

					if (checked) {
						this.showTotal = true;
						$(`.${this.tabId}`)
							.find('.pvtTotal, .pvtTotalLabel, .pvtGrandTotal')
							.show();
					} else {
						this.showTotal = false;
						$(`.${this.tabId}`)
							.find('.pvtTotal, .pvtTotalLabel, .pvtGrandTotal')
							.hide();
					}
				});

				// Get all buttons inside .pvtFilterBox
				const pvtFilterBoxBtn = document.querySelectorAll('.pvtFilterBox button');

				// Add class to pvtFilterBox buttons
				for (var i = 0; i < pvtFilterBoxBtn.length; ++i) {
					pvtFilterBoxBtn[i].classList.add('pvtFilterBoxBtn');

					if (pvtFilterBoxBtn[i].innerText === 'Cancel') {
						pvtFilterBoxBtn[i].classList.add('none');
					}

					if (pvtFilterBoxBtn[i].innerText === 'Select None') {
						pvtFilterBoxBtn[i].classList.add('none');
					}
				}
			},

			// Converting the string to an array buffer
			s2ab(s) {
				if (typeof ArrayBuffer !== 'undefined') {
					var buf = new ArrayBuffer(s.length);
					var view = new Uint8Array(buf);
					for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
					return buf;
				} else {
					var buf = new Array(s.length);
					for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xff;
					return buf;
				}
			},
			exportTableToExcel(type, tabId, fn) {
				var _id = Math.floor(100000 + Math.random() * 900000);
				var output = $("<table id='" + _id + "' class='hidden' >");
				var rowcount = 0;
				$(`#${tabId}`)
					.children()
					.clone()
					.appendTo(output);
				output.appendTo('body');

				$('#' + _id)
					.find('.pvtTotal, .pvtTotalLabel, .pvtGrandTotal')
					.remove();
				$('#' + _id)
					.find('td')
					.each(function() {
						var val = $(this).html();
						let a = val.replace(/ /g, '');
						let b = a.replace(/,/g, '.');
						$(this).text(b);
					});
				$('#' + _id)
					.find('th')
					.each(function() {
						var val = $(this).text();
						$(this).text('"' + val + '"');
						$(this).attr('data-t', 's');
					});

				var book = document.getElementById(_id);
				var wb = XLSX.utils.table_to_book(book, { Author: 'Bonnier Pharma Insights' }, { sheet: 'BPI' });

				/* find from where we should remove merges. (second A after A1)*/
				var alphaCode = [
					'A',
					'B',
					'C',
					'D',
					'E',
					'F',
					'G',
					'H',
					'I',
					'J',
					'K',
					'L',
					'M',
					'N',
					'O',
					'P',
					'Q',
					'R',
					'S',
					'T',
					'U',
					'V',
					'W',
					'X',
					'Y',
					'Z',
				];
				var rowRef = wb.Sheets['Sheet1']['!ref'];
				var colRef = wb.Sheets['Sheet1']['!ref'];
				rowRef = rowRef.replace('A1:', '');
				rowRef = rowRef.replace(/\D/g, ''); //get Max Row Number
				colRef = colRef.replace('A1:', '');
				colRef = colRef.replace(/\d+/g, ''); //get Max Col ID

				var secondA = 1;
				for (let i = 2; i < rowRef; i++) {
					if (wb.Sheets['Sheet1']['A' + i] !== undefined) {
						secondA = i - 1;
						break;
					}
				}
				for (let i = 0; i < wb.Sheets['Sheet1']['!merges'].length; i++) {
					if (wb.Sheets['Sheet1']['!merges'][i]['s']['r'] > secondA) {
						wb.Sheets['Sheet1']['!merges'].splice(i, 1);
						i--; //because splice changes the keys;
					}
				}
				//unmerge Measurement
				var moveHeader = null;
				var headerRow = null;
				for (let j = 1; j < alphaCode.length; j++) {
					if (wb.Sheets['Sheet1'][alphaCode[j] + 1] !== undefined) {
						moveHeader = j - 1;
						break;
					}
				}
				for (let i = 0; i < wb.Sheets['Sheet1']['!merges'].length; i++) {
					if (
						wb.Sheets['Sheet1']['!merges'][i]['s']['c'] > moveHeader &&
						wb.Sheets['Sheet1']['!merges'][i]['s']['r'] == secondA - 1
					) {
						wb.Sheets['Sheet1']['!merges'].splice(i, 1);
						i--; //because splice changes the keys;
					}
				}
				//fix Measurement Merge
				moveHeader = moveHeader + 1;
				// move to next row.

				//now non existing objects to fix merges;

				var breakAfterNext = false;
				for (let i = 0; i < 26; i++) {
					//traversing columns
					var prevObj = '';
					if (breakAfterNext) {
						breakAfterNext = false;
						break;
					}
					if (alphaCode[i] == colRef) {
						breakAfterNext = true;
					}
					for (let j = secondA + 2; j < rowRef; j++) {
						//traversing rows
						let col = alphaCode[i] + j;
						if (wb.Sheets['Sheet1'][col] !== undefined) {
							prevObj = wb.Sheets['Sheet1'][col];
						} else {
							wb.Sheets['Sheet1'][col] = prevObj;
						}
					}
				}

				//delete wb.Sheets["Sheet1"]['!merges'];
				/*end merges*/
				//console.log(wb.Sheets["Sheet1"]);

				for (var obj in wb.Sheets['Sheet1']) {
					if (wb.Sheets['Sheet1'][obj]['v'] !== undefined) {
						//If type is string, check if it contains only numbers and comma.
						if (wb.Sheets['Sheet1'][obj]['t'] == 's') {
							//if(/^[0-9,."'\\\s\-]*$/.test(wb.Sheets["Sheet1"][obj]['v'])) {
							//Here we remove the quotation marks that we put earlier arround year
							var v = wb.Sheets['Sheet1'][obj]['v'].replace(/\"/g, '');
							wb.Sheets['Sheet1'][obj]['v'] = v;
							wb.Sheets['Sheet1'][obj]['z'] = 'General';
							//}
						} else if (wb.Sheets['Sheet1'][obj]['t'] == 'n') {
							/* new format */
							var fmt = '# ### ##0.00';
							wb.Sheets['Sheet1'][obj]['z'] = fmt;
						}
					}
				}

				var wbout = XLSX.write(wb, {
					bookType: type,
					bookSST: true,
					type: 'binary',
				});
				var fname = fn || tabId + '.' + type;

				const dt = new Date();
				const year = dt.getFullYear();
				const month = ('0' + (dt.getMonth() + 1)).slice(-2);
				const day = ('0' + dt.getDate()).slice(-2);
				const hours = dt.getHours();
				const minutes = dt.getMinutes();

				const filename = `pmx_export_${year}.${month}.${day}_${hours}.${minutes}.${type}`;

				try {
					FileSaver(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), filename);
				} catch (e) {
					if (typeof console != 'undefined') console.log(e, wbout);
				}
				$('#' + _id).remove();

				return wbout;
			},
		},
	};
</script>

<style lang="scss">
	.switch {
		position: relative;
		display: inline-block;
		width: 40px;
		/* height: 34px; */
	}

	.switch input {
		opacity: 0;
		width: 0;
		height: 0;
	}

	.slider {
		position: absolute;
		cursor: pointer;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #ccc;
		-webkit-transition: 0.4s;
		transition: 0.4s;
	}

	.slider:before {
		position: absolute;
		content: '';
		height: 16px;
		width: 16px;
		left: 4px;
		bottom: 4px;
		background-color: white;
		-webkit-transition: 0.4s;
		transition: 0.4s;
	}

	input:checked + .slider {
		background-color: #1867c0;
	}

	input:focus + .slider {
		box-shadow: 0 0 1px #1867c0;
	}

	input:checked + .slider:before {
		-webkit-transform: translateX(16px);
		-ms-transform: translateX(16px);
		transform: translateX(16px);
	}

	/* Rounded sliders */
	.slider.round {
		border-radius: 34px;
	}

	.slider.round:before {
		border-radius: 50%;
	}

	.pivot-table-container {
		background: #f5f5f5 !important;
		/* background: salmon !important; */
	}

	.pivot-table {
		overflow: auto;
		background: #fff;
		padding: 24px;
		border-radius: 4px !important;

		/* Collapse table border */
		table {
			border-collapse: collapse;
		}

		.pivot-btn {
			padding: 0 8px;
			height: 2rem;
			/* min-width: 64px; */
			background-color: #1867c0;
			border-radius: 5px;
			color: #fff;
			margin: 0 6px;
			font-weight: 500;
		}

		.pvtFilterBox {
			border-radius: 5px;

			& .count {
				display: none;
			}

			& .pvtSearch {
				padding: 3px;
				margin-bottom: 8px;
				border: 1px solid #eee;
				border-radius: 5px;
				width: 90%;
			}

			& .pvtFilterBoxBtn {
				padding: 0 8px;
				height: 2rem;
				min-width: 64px;
				background-color: #1867c0;
				border-radius: 5px;
				color: #fff;
				margin-right: 6px;
				margin-left: 6px;
				font-weight: 500;

				&.none {
					background: transparent;
					color: #1867c0;
					border: 1px #1867c0 solid;
				}
			}
		}

		.pvtAxisContainer,
		.pvtVals {
			background: #fff;
			border: 1px solid #ddd;

			/* Hide row & col order */
			& a.pvtRowOrder,
			& a.pvtColOrder {
				display: none;
			}

			li span.pvtAttr {
				background: #fff;
			}
		}

		.pvtFilteredAttribute {
			font-weight: bold;
			font-style: normal;

			& .pvtAttr {
				border: 2px solid #000;

				& .pvtTriangle {
					color: #000;
				}
			}
		}

		/* Aggregator */
		.pvtAggregator {
			margin-bottom: 0;
		}

		td select {
			border: 1px solid #ddd;
			border-radius: 5px;
			padding: 3px;
			width: 95%;
			background: transparent;
		}

		/* Result area */
		.pvtRendererArea {
			padding: 5px 0px 0px 5px;
		}

		/* Background color changes when filtering, set default background color */
		table.pvtTable tbody tr th,
		table.pvtTable thead tr th,
		table.pvtTable.pvtFixedHeader th > div.pvtFixedHeader {
			background-color: #eee;
		}

		/* Hide the totals column */
		/* .pvtTotal,
    .pvtTotalLabel,
    .pvtGrandTotal {
        display: none;
    } */

		/* Display numbers in one line with no wrapping */
		table.pvtTable tbody tr td {
			white-space: nowrap;
		}
	}
</style>
